import useScrollProgress from './hooks/useScrollProgress';
import useInView from './hooks/useInView';

import ScrollProgress from './components/ScrollProgress';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import FounderStory from './components/FounderStory';
import CoreProblem from './components/CoreProblem';
import Approach from './components/Approach';
import Program from './components/Program';
import WhoItsFor from './components/WhoItsFor';
import Curriculum from './components/Curriculum';
import Cohort from './components/Cohort';
import Pricing from './components/Pricing';
import InHouseTraining from './components/InHouseTraining';
import Guarantee from './components/Guarantee';
import Faq from './components/Faq';
import Contact from './components/Contact';
import FinalCta from './components/FinalCta';
import Footer from './components/Footer';
import FloatingCta from './components/FloatingCta';
import HtmlEmbed from './components/ui/HtmlEmbed';
import { iclosedLoader } from './data/content';

export default function App() {
  const { progress, scrolledPastFold } = useScrollProgress();
  /* the floating CTA steps aside once the footer is reached */
  const footerInView = useInView('footer');

  return (
    <>
      <ScrollProgress progress={progress} />
      <Nav />

      <main>
        <Hero />
        <Testimonials />
        <FounderStory />
        <CoreProblem />
        <Approach />
        <Program />
        <WhoItsFor />
        <Curriculum />
        <Cohort />
        <Pricing />
        <InHouseTraining />
        <Guarantee />
        <Faq />
        <Contact />
        <FinalCta />
      </main>

      <Footer />
      <FloatingCta visible={scrolledPastFold && !footerInView} />

      {/* iClosed popup loader — one per page; it binds to every CTA carrying
          data-iclosed-link and data-embed-type="popup" */}
      <HtmlEmbed html={iclosedLoader} />
    </>
  );
}
